import { JsonProperty } from '../utils/json-typescript-mapper';
import { BaseModel } from './base.model';

export class UrlScheme extends BaseModel<UrlScheme> {

    @JsonProperty('UrlScheme')
    scheme: string;

    constructor(properties?: Partial<UrlScheme>) {
        super({
            scheme: undefined
        }, properties);
    }
}
